import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { DedicateFlashMessageRequest } from './dedicateflashmessagesrequest';

export class DedicateFlashMessageAPI extends SixdeeCRBTAPI<DedicateFlashMessageRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }
    getAPIURL(): string
    { 
        return "flash/subscriber-management/subscribers/special-flash-messages-setting";
    }

    protected getRequestData() {
        return {
            "msisdn": this.getRequest().getFlashMessageRequest().getMsisdn(),
            "flashSettingName":"Dedicate Special Caller",
            "startTime": "00:00:00",
            "endTime": "23:59:59",
            "startDate": "2023-01-01",
            "endDate": "2033-12-31",
            "weeklyDays": [1,2,3,4,5,6,7],
            "flashMessage":this.getRequest().getFlashMessageRequest().getStatusMessage(),
            "dedicationDetailsList": [
            {
                "name": "Special Caller Note4U",
                "msisdn": this.getRequest().getFlashMessageRequest().getDedicateFlashDtos()[0].getNumber()
            }
            ]
        };
    }

    // {
    //     "flashSettingName": "New Year",
    //     "flashMessage": "Happy New Year",
    //     "startTime": "00:00:00",
    //     "endTime": "23:59:59",
    //     "weeklyDays": [
    //       1,
    //       2,
    //       3,
    //       4,
    //       5,
    //       6,
    //       7
    //     ],
    //     "startDate": "2023-01-01",
    //     "endDate": "2033-12-31",
    //     "dedicationDetailsList": [
    //       {
    //         "name": "Dad",
    //         "msisdn": "9786543213"
    //       },
    //       {
    //         "name": "Mom",
    //         "msisdn": "8765456543"
    //       }
    //     ]
    //   }
    getBASEURL(): string
    {
        return this.getContext().getProperty().getFlashURL() + 
            this.getAPIURL();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/dedicate/dedicateflashmessagesapi.tsx